<!--
 * @Author: your name
 * @Date: 2021-03-02 19:05:38
 * @LastEditTime: 2022-03-24 17:10:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\materialList.vue
-->
<template>
  <!-- <div :style="vdr"> -->
    <div
        class="vdr-window"
        data-type="vdr-window"
        :style="vdrStyle"
        v-if="resize"
        @dragover="dragover"
        @drop.stop="drop($event,'window')"
    >
      <k-draggable-vue
        class="vdr-border"
        ref="kdv"
        :active-window-id="activeId"
        :width="vdrw*scale"
        :height="vdrh*scale"
        :scale="1"
        :window-list="windowList"
        :create-window-by-mouse="false"
        :create-window-dom="null"
        :limitations="true"
        :min-size="minSize"
        :adsorb-options="adsorbOptions"
        :adsorb-coord-more="adsorbCoordMore"
        @window-mousedown="windowMousedown"
        @window-mouseup="windowMouseup">
        <!-- 
        @window-created="windowCreated"
        @before-scale="loadRectify"
      > -->
        <template v-slot:windowInfo="{winInfo}">
          <div style="user-select: none;"
            :id="`vdr-${winInfo.id}`"
            class="vdr-wicket"
            data-type="wicket"
            @dragover="dragover"
            @drop.stop="drop($event,'wicket')"
            @mouseenter="displayKey"
            @mouseleave="disappearKey"
          >
            <div style="height: 100%; width: 100%;">
              <div
                  class="wicket-child"
                  v-for="(wicketVdr,wicketKey) in vdrList[vdrList.findIndex((vdr) => vdr.idx == winInfo.id)].wicket"
                  :key="wicketVdr.field"
                  v-show="vdrList[vdrList.findIndex((vdr) => vdr.idx == winInfo.id)].activeIndex === wicketKey"
                >
                  <component v-bind:is="currentComponent(wicketVdr.type)" :media="wicketVdr"></component>
              </div>
            </div>
            <div class="keys" :style="`transform: translateY(-${winInfo.style.h}px)`" v-show="mouseEnterId == winInfo.id">
              <el-tooltip content="铺满整个屏幕" placement="top" effect="light">
                <el-button @click="fullScreen" class="key" v-show="activ" icon="el-icon-full-screen"></el-button>
              </el-tooltip>
              <el-tooltip content="还原" placement="top" effect="light">
                <el-button @click="discoveryWin" class="key" v-show="!activ" icon="el-icon-copy-document"></el-button>
              </el-tooltip>
              <el-tooltip content="关闭窗口" placement="top" effect="light">
                <el-button @click="closeWin" class="key" v-show="true" icon="el-icon-close"></el-button>
              </el-tooltip>
            </div>
          </div>
        </template>
      </k-draggable-vue>

        <template>
          <span
            class="ref-line v-line"
            v-for="(item, index) in vLine"
            v-show="item.display"
            :style="{ left: item.position + 'px', top: item.origin + 'px', height: item.lineLength + 'px'}"
            :key="`v-line-${index}`"
          />
          <span
            class="ref-line h-line"
            v-for="(item, index) in hLine"
            v-show="item.display"
            :style="{ top: item.position + 'px', left: item.origin + 'px', width: item.lineLength + 'px'}"
            :key="`h-line-${index}`"
          />
        </template>
        <!--辅助线END-->
      
      <!-- Kommander屏幕网格 -->
      <template v-if="vdrInfor.deviceType === 'Kommander'">
        <div class="screen flex-d-c-c" v-for="(screen, index) in gridList" :key="index" :style="screenStyle(screen)">
          <span>{{screen.name}}</span>
          <span class="s-text">{{`${screen.w}X${screen.h}`}}</span>
          <span class="s-text">{{`${screen.x},${screen.y}`}}</span>
        </div>
      </template>
      <span class="prompt" v-show="showPrompt()">{{$t('PE.DragMaterial')}}</span>
    </div>
  <!-- </div> -->
</template>

<script>
// import * as TemplateData from "@/assets/scripts/programData.js"
import ToolWeather from './ToolsList/ToolWeather'
import ToolCalendar from './ToolsList/ToolCalendar'
import ToolCountdown from './ToolsList/ToolCountdown'
import ToolIClock from './ToolsList/ToolIClock'
import ToolImage from './ToolsList/ToolImage'
import ToolMedia from './ToolsList/ToolMedia'
import ToolNClock from './ToolsList/ToolNClock'
import ToolRss from './ToolsList/ToolRss'
import ToolText from './ToolsList/ToolText'
import ToolTimewait from './ToolsList/ToolTimewait'
import ToolVideo from './ToolsList/ToolVideo'
import ToolWebpage from './ToolsList/ToolWebpage'
import { addMaterialTools } from "../mixins";
import toolsList from '@/assets/scripts/toolsList.js';

export default {
  name: 'Vdr',
  mixins: [addMaterialTools],
  components: {
    ToolWeather,
    ToolCalendar,
    ToolCountdown,
    ToolIClock,
    ToolImage,
    ToolMedia,
    ToolNClock,
    ToolRss,
    ToolText,
    ToolTimewait,
    ToolVideo,
    ToolWebpage
  },
  inject: {
    vdrInfor: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      activeId: 0,
      // scale: 1,
      vdrw: 0,
      vdrh: 0,
      vLine: [],
      hLine: [],
      resize: true,
      gridList: [],
      toolsList: toolsList(),
      // winSize: null,
      windowList: [],
      currentWindow: {},
      record: [],
      activ: true,
      mouseEnterId: -1,
      adsorbOptions: [
        { 
            prop: 'disabled',   ////是否禁用吸附功能；
            value: false 
        }, 
        { 
            prop: 'threshold',  //吸附最小阈值
            value: 15 
        }, 
        { 
            prop: 'preAdsorptionLine',  //预吸附提示线
            value: true 
        }, 
        { 
            prop: 'preAdsorptionThreshold', //预吸附提示线阈值
            value: 30
        }, 
        { 
            prop: 'adsorbedLine',   //已吸附提示线
            value: true 
        }
      ],
      adsorbCoordMore: [],
      timerId: 0   //定时器
    }
  },
  created() {
    this.vdrw = Number(this.vdrInfor.w);
    this.vdrh = Number(this.vdrInfor.h);
    // this.winSize = { w: this.vdrInfor.w, h: this.vdrInfor.h };
    this.$store.commit("VDR_WINDOW_SIZE", { vdrw: this.vdrw, vdrh: this.vdrh });
    // 设备选择
    this.vdrInfor.deviceType === 'Pandora' && this.pandoraInit();
    this.vdrInfor.deviceType === 'Kommander' && this.kommanderInit();
  },

  methods: {
    pandoraInit() {
    },
    kommanderInit() {
      this.gridList = JSON.parse(this.vdrInfor.gridList);
    },
    showPrompt() {
      if (this.vdrListLength === 0) {
        return true;
      }
      if (this.vdrListLength === 1 && this.vdrList[this.vdrIndex].wicket.length === 0) {
        return true;
      }
    },
    // getBackgroundLine() {
    //   let w = (this.vdrw / 3) * this.ratio;
    //   let h = (this.vdrh / 4) * this.ratio;
    //   // 此处不要换行
    //   return `linear-gradient(-90deg,rgba(255, 255, 255, 0.5) 1px,transparent 1px) 0px 0px / ${w}px ${w}px,
    //   linear-gradient(rgba(255, 255, 255, 0.5) 1px, transparent 1px) 0% 0% / ${h}px ${h}px`;
    // },
    // 窗口中当前显示组件
    currentComponent(type) {
      let tool = this.toolsList.find(tool => tool.type == type);
      if (tool) {
        return tool.tool;
      } else {
        return "";
      }
      // switch (type) {
      //   case "5": return "ToolWeather";
      //   // case "11": return "ToolCalendar";
      //   case "12": return "ToolCountdown";
      //   case "7": return "ToolIClock";
      //   case "2": return "ToolImage";
      //   case "14": return "ToolMedia";
      //   case "6": return "ToolNClock";
      //   case "17": return "ToolRss";
      //   case "4": return "ToolText";
      //   case "13": return "ToolTimewait";
      //   case "1": return "ToolVideo";
      //   default: return "";
      // }
    },
    
    // 辅助线回调事件
    getRefLineParams(params) {
      this.adsorbCoordMore = [];
      const [ vLine, hLine ] = params;
      this.vLine = vLine;
      this.hLine = hLine;
      const w = this.vdrw / (vLine.length + 1) * this.scale
      const h = this.vdrh / (hLine.length + 1) * this.scale
      for (let index1 = 0; index1 < vLine.length + 1; index1++) {
        for (let index2 = 0; index2 < hLine.length + 1; index2++) {
          this.adsorbCoordMore.push({x:w*index1,y:h*index2,w:w,h:h})
        }
      }
    },
    // 当前激活组件
   
    dragover(event) {
      event.preventDefault();
    },
    drop(event, wType) {
      // 添加素材与工具到子窗口
      wType === 'wicket' && this.addWicket(event, wType);
      // 添加素材到画布窗口，自动创建子窗口添加素材
      // window
      wType === 'window' && this.addWindow(event, wType);
      /** 
      let vdrId = -1;
      let vdrElement = document.getElementById(event.dataTransfer.getData("selectVdr"));
      // console.log(vdrElement);
      if (!vdrElement) { return; }
      // console.log(vdrElement);
      // let mediaUrl = vdrElement.getAttribute("data-media");
      // let thumbUrl = vdrElement.getAttribute("data-thumb");
      // let dragId = vdrElement.getAttribute("id").split("-")[1];
      let mediaTemplate = JSON.parse(vdrElement.getAttribute("data-template"));
      let mediaType = vdrElement.getAttribute("data-type");
      // 查找父级窗口id
      let targetNode = event.target;
      while (targetNode.getAttribute("data-type") !== "wicket") {
        targetNode = targetNode.parentNode;
        if (event.target.nodeName === "BODY") { return; }
      }
      vdrId = targetNode.getAttribute("id").split("-")[1];

      // if (event.target.parentNode.getAttribute("data-type") === "wicket") {
      //   console.log(event.target.parentNode);
      //   vdrId = event.target.parentNode.getAttribute("id").split("-")[1];
      // } else {
      //   console.log(event.target);
      //   vdrId = event.target.getAttribute("id").split("-")[1];
      // }
      // 查找当前需要激活窗口
      let index = this.vdrList.findIndex((vdr) => vdr.idx == vdrId);
      // 添加数据
      let idMax = -1;
      this.vdrList[index].wicket.forEach((wicketChild) => {
        wicketChild.id > idMax && (idMax = wicketChild.id);
      });

      // start ; true 为媒体文件 false为工具组件
      let templateData = this.getTemplateData(mediaType);
      // console.log(templateData);
      // console.log(mediaTemplate);
      if (mediaTemplate.id || mediaTemplate.group_id) {
        templateData.field_item_id = mediaTemplate.id;
        templateData.ext_val_name = mediaTemplate.ref_name;
        templateData.ext_val_pimg = mediaTemplate.ref_thumb_url;
        templateData.field_item_path = mediaTemplate.ref_url;
        templateData.ext_val_size = mediaTemplate.ref_size;
        templateData.field_item_playTime = mediaTemplate.ref_time;
      } else {
        templateData.field_item_id = this.$uuid.v4();
        templateData.ext_val_pimg = mediaTemplate.image;
      }
      templateData.w = this.vdrList[index].w;
      templateData.h = this.vdrList[index].h;
      // end
      this.vdrList[index].wicket.push(templateData);
      // this.vdrList[index].wicket.push({
      //   // mediaUrl: mediaUrl,
      //   // thumbUrl: thumbUrl,
      //   // index: dragId,
      //   // type: mediaType,
      //   id: idMax + 1
      // });

      // 激活父级窗口
      this.vdrList[index].active = true;
      // 激活子级窗口
      this.vdrList[index].activeIndex = this.vdrList[index].wicket.length - 1;
      // 数据同步
      this.$store.commit("VDR_INDEX", index);
      // this.$store.commit('VDR_CHILD_INDEX', this.vdrList[index].wicket.length - 1);
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[index]);
      */
    },
    screenStyle(style) {
      return `width: ${style.w * this.ratio}px; height: ${style.h * this.ratio}px; left: ${style.x * this.ratio}px; top: ${style.y * this.ratio}px;`;
    },
    addWicket(event) {
      let vdrElement = document.getElementById(event.dataTransfer.getData("selectVdr"));
      if (!vdrElement) { return; }
      // 获取工具或素材信息
      let mediaTemplate = JSON.parse(vdrElement.getAttribute("data-template"));
      let mediaType = vdrElement.getAttribute("data-type");
      // 查找当前需要加入素材或工具的窗口
      let targetNode = event.target;
      while (targetNode.getAttribute("data-type") !== "wicket") {
        targetNode = targetNode.parentNode;
        if (event.target.nodeName === "BODY") { return; }
      }
      // 查找当前需要激活窗口
      let vdrId = targetNode.getAttribute("id").split("-")[1];
      let index = this.vdrList.findIndex((vdr) => vdr.idx == vdrId);
      // let index = Number(vdrId);
      this.addWindowChild(mediaTemplate, mediaType, index);
    },
    addWindow(event) {
      let vdrElement = document.getElementById(event.dataTransfer.getData("selectVdr"));
      if (!vdrElement) { return; }
      // console.log(event);
      let mediaTemplate = JSON.parse(vdrElement.getAttribute("data-template"));
      let mediaType = vdrElement.getAttribute("data-type");
      let offset = JSON.parse(vdrElement.getAttribute("data-offset")); // 偏移位置
      // console.log(offset);
      let x = (event.offsetX / this.scale) - Math.ceil(this.vdrInfor.w * 0.25 * offset.percentageX);
      let y = (event.offsetY / this.scale) - Math.ceil(this.vdrInfor.h * 0.25 * offset.percentageY);
      let point = this.setPoint(x, y);
      // this.vdrInfor.w*0.25
      //判断鼠标在哪个分区
      const wt = this.vdrw / (this.vLine.length + 1); //真实的宽
      const ht = this.vdrh / (this.hLine.length + 1); //真实的高
      const w = wt * this.scale; //缩放后的宽
      const h = ht * this.scale; //缩放后的高

      for (let i = 0; i < this.vLine.length + 1; i++) {
        for (let j = 0; j < this.hLine.length + 1; j++) {
          if ((event.offsetX >= i*w && event.offsetX <= (i+1)*w) && (event.offsetY >= j*h && event.offsetY <= (j+1)*h)) {
            if (this.vdrList.length) {     //如果有长度，则判断分区里面是否有其他窗口，没有则全屏占满整个分区
              const a = this.vdrList.findIndex((item) => 
                (item.x >= i*wt) && (item.x < (i+1)*wt) && (item.y >= j*ht) && (item.y < (j+1)*ht)
              )
              a !== -1 && this.addVdrWindow(point.x, point.y);
              a === -1 && this.addVdrWindow(i*wt,j*ht,wt,ht)
            } 
            else {
              this.addVdrWindow(i*wt,j*ht,wt,ht)
            }
          } 
        }        
      }
      // this.addVdrWindow(point.x, point.y);
      this.addWindowChild(mediaTemplate, mediaType);
    },
    setPoint(x, y) {
      // 限制最小值
      x = x < 0 ? 0 : x;
      y = y < 0 ? 0 : y;
      // 限制最大值
      const xmax = this.vdrInfor.w - Math.ceil(this.vdrInfor.w * 0.25);
      const ymax = this.vdrInfor.h - Math.ceil(this.vdrInfor.h * 0.25)
      x = x > xmax ? (xmax - 1) : x;
      y = y > ymax ? (ymax - 1) : y;
      // 返回坐标
      return { x, y }
    },
    // addWindowChild(mediaTemplate, mediaType, index = this.vdrIndex) {
    //   let templateData = this.getTemplateData(mediaType);
    //   // start ; true 为媒体文件 false为工具组件
    //   if (mediaTemplate.id || mediaTemplate.group_id) {
    //     templateData.field_item_id = mediaTemplate.id;
    //     templateData.field_item_nodeId = this.$uuid.v4();
    //     templateData.ext_val_name = mediaTemplate.ref_name;
    //     templateData.ext_val_pimg = mediaTemplate.ref_thumb_url;
    //     templateData.field_item_path = mediaTemplate.ref_url;
    //     templateData.ext_val_size = mediaTemplate.ref_size;
    //     templateData.field_item_playTime = mediaTemplate.ref_time;
    //   } else {
    //     templateData.field_item_id = this.$uuid.v4();
    //     templateData.field_item_nodeId = this.$uuid.v4();
    //     templateData.ext_val_pimg = mediaTemplate.image;
    //   }
    //   templateData.w = this.vdrList[index].w;
    //   templateData.h = this.vdrList[index].h;
    //   // end
    //   this.vdrList[index].wicket.push(templateData);
    //   // 激活父级窗口
    //   this.vdrList[index].active = true;
    //   // 激活子级窗口
    //   this.vdrList[index].activeIndex = this.vdrList[index].wicket.length - 1;
    //   // 数据同步
    //   this.$store.commit("VDR_INDEX", index);
    //   this.$store.commit("VDR_LIST_EDIT", this.vdrList[index]);
    // },
    // // 获取窗口数据
    // getTemplateData(type) {
    //   switch (type) {
    //     case "5": return TemplateData.dataWeather();
    //     // case "11": return TemplateData.dataCalendar();
    //     case "12": return TemplateData.dataCountdown();
    //     case "7": return TemplateData.dataIClock();
    //     case "2": return TemplateData.dataImage();
    //     case "14": return TemplateData.dataMedia();
    //     case "6": return TemplateData.dataNClock();
    //     case "17": return TemplateData.dataRss();
    //     case "4": return TemplateData.dataText();
    //     case "13": return TemplateData.dataTimewait();
    //     case "1": return TemplateData.dataVideo();
    //     default: return "";
    //   }
    // },
    // addVdrWindow(x = 10, y = 10, w = 0, h = 0) {
    //   let idMax = -1;
    //   let zIndexMax = -1;
    //   this.vdrList.forEach((vdr) => {
    //     vdr.idx > idMax && (idMax = vdr.idx);
    //     vdr.zIndex > zIndexMax && (zIndexMax = vdr.zIndex);
    //   });
    //   this.$store.commit("VDR_LIST_ADD", {
    //     type: "10",
    //     field: `wicket_${this.$uuid.v4()}`,
    //     field_cn: "窗口",
    //     idx: idMax + 1,
    //     zIndex: zIndexMax + 1,  // 组件当前层级
    //     activeIndex: 0,  // 当前激活子组件
    //     active: false,  //是否立即激活
    //     style: {
    //       fs: "0",
    //       ha: "0",
    //       va: "0"
    //     },
    //     x: x,
    //     y: y,
    //     w: w !== 0 ? w : parseInt(this.vdrInfor.w * 0.25),
    //     h: h !== 0 ? h : parseInt(this.vdrInfor.h * 0.25),
    //     wicket: []
    //   });
    //   this.$store.commit("VDR_INDEX", this.vdrListLength - 1);
    //   if (this.vdrListLength === 1) {
    //     setTimeout(() => {
    //       this.$store.commit("VDR_WIN_FULL", { x: 0, y: 0, w: this.vdrWindowSize.vdrw, h: this.vdrWindowSize.vdrh });
    //       this.setStyle('fs', 1);
    //     }, 100)
    //   }
    // }
    // addWindowList(){
    //   this.windowList = []
    //   const scale = this.scale
    //   for (let index = 0; index < this.vdrList.length; index++) {
    //     const {x,y,w,h,zIndex} = this.vdrList[index]
    //     this.windowList.push({id:index,style: {x:x*scale,y:y*scale,w:w*scale,h:h*scale,zIndex,bg:'transparent'}})
    //   }
    // },
    windowMousedown (res) {
      let index = this.vdrList.findIndex((vdr) => vdr.idx == res.windowInfo.id);
      this.$store.commit("VDR_INDEX", index);
    },
    windowMouseup () {
    },
    // windowCreated (res) {
      // let {x,y,w,h} = res.style;
      // x = x / this.scale;
      // y = y / this.scale;
      // w = w / this.scale;
      // h = h / this.scale;
      // if(w == 0 && x > this.vdrw * 0.75) 
      // {w = this.vdrw - x}
      // if(h == 0 && y > this.vdrh * 0.75) 
      // {h = this.vdrh - y}
      // this.addVdrWindow(x,y,w,h)
      // console.log('windowCreated-------->', res);
    // },

    //添加窗口
    addWindowList(){
      if (this.vdrInfor.type === 'add') {
        const i = this.scale
        const {idx,x,y,w,h,zIndex} = this.vdrList[this.vdrIndex];
        this.windowList.push({id:idx,style: {x:x*i,y:y*i,w:w*i,h:h*i,zIndex,bg:'transparent'}});
        this.record.push({activ:true,win:{idx,x,y,w,h}});
      }
      else if (this.vdrInfor.type === 'edit') {
        if (this.vdrList.length - this.windowList.length !== 1) {
          this.vdrList.forEach(element => {
            const {idx,x,y,w,h,zIndex} = element;
            this.windowList.push({id:idx,style:{x:x*this.scale,y:y*this.scale,w:w*this.scale,h:h*this.scale,zIndex,bg:'transparent'}});
            this.record.push({activ:true,win:{idx,x,y,w,h}});
          });
        } else {
          const i = this.scale
          const {idx,x,y,w,h,zIndex} = this.vdrList[this.vdrIndex];
          this.windowList.push({id:idx,style: {x:x*i,y:y*i,w:w*i,h:h*i,zIndex,bg:'transparent'}});
          this.record.push({activ:true,win:{idx,x,y,w,h}});
        }
        // this.vdrInfor.type === 'add'
      }
      else {
        this.upDateWindowList(this.scale)
      }
    },
    //删除窗口
    deleteWindowList(){
      const id = this.vdrList.map((x) => x.idx);
      const index1 = this.windowList.findIndex(element => 
          id.find(element1 => element.id == element1) == undefined
        );
      const index2 = this.record.findIndex(element => 
        id.find(element1 => element.win.idx == element1) == undefined
      );
      this.windowList.splice(index1,1);
      this.record.splice(index2,1)
    },
    //修改窗口大小、位置
    changeWindowList(i){
      const vdrid = this.vdrList.map((item) => item.idx);
      const winid = this.windowList.map((item) => item.id);
      if (JSON.stringify(vdrid) !== JSON.stringify(winid)) {
        this.upDateWindowList(this.scale)
      } else {
        const {x,y,w,h,zIndex} = this.vdrList[this.vdrIndex]
      this.windowList[i].style.x = x*this.scale
      this.windowList[i].style.y = y*this.scale
      this.windowList[i].style.w = w*this.scale
      this.windowList[i].style.h = h*this.scale
      this.windowList[i].style.zIndex = zIndex
      }
      
    },
    //保存windowList的参数到vdrList的值
    changeVdrList(){
      const i = this.scale;
      const {idx,x,y,w,h,zIndex} = this.vdrList[this.vdrIndex];
      const obj = {id:idx,style:{x:x*i,y:y*i,w:w*i,h:h*i,zIndex,bg:'transparent'}}
      if (this.windowList[this.vdrIndex] !== obj) {
        this.vdrList[this.vdrIndex].x = this.windowList[this.vdrIndex].style.x / this.scale;
        this.vdrList[this.vdrIndex].y = this.windowList[this.vdrIndex].style.y / this.scale;
        this.vdrList[this.vdrIndex].w = this.windowList[this.vdrIndex].style.w / this.scale;
        this.vdrList[this.vdrIndex].h = this.windowList[this.vdrIndex].style.h / this.scale;
        this.vdrList[this.vdrIndex].wicket.forEach(wicket => {
          wicket.w = this.vdrList[this.vdrIndex].w;
          wicket.h = this.vdrList[this.vdrIndex].h;
        });
        this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);  
      }
    },
    //scale/ratio改变时更新窗口
    upDateWindowList(val){
      this.windowList = [];
      this.vdrList.forEach(element => {
        const {idx,x,y,w,h,zIndex} = element;
        this.windowList.push({id:idx,style:{x:x*val,y:y*val,w:w*val,h:h*val,zIndex,bg:'transparent'}});
      });
    },
    //点击使之铺满整个屏幕
    fullScreen(){
      if ((this.vdrList[this.vdrIndex].w !== this.vdrw) || (this.vdrList[this.vdrIndex].h !== this.vdrh)) {
        const id = this.vdrList[this.vdrIndex].idx;
        const i = this.record.findIndex((element)=>element.win.idx === id);
        const j = this.vdrList.findIndex((element)=>element.idx === id);
        const {idx,x,y,w,h} = this.vdrList[j];
        this.record[i].win = {idx,x,y,w,h};
        this.$store.commit("VDR_WIN_FULL", { x: 0, y: 0, w: this.vdrWindowSize.vdrw, h: this.vdrWindowSize.vdrh });
        // this.activ = false
        this.activ = this.record[i].activ = false;
      }
    },
    //点击恢复窗口大小
    discoveryWin(){
      const i = this.record.findIndex(element=>
        element.win.idx === this.windowList[this.vdrIndex].id
      );
      this.vdrList[this.vdrIndex].x = this.record[i].win.x;
      this.vdrList[this.vdrIndex].y = this.record[i].win.y;
      this.vdrList[this.vdrIndex].w = this.record[i].win.w;
      this.vdrList[this.vdrIndex].h = this.record[i].win.h;
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);
      // this.activ = true
      this.activ = this.record[i].activ = true;
    },
    //删除窗口
    closeWin(){
      const idx = this.vdrList[this.vdrIndex].idx;
      this.$store.commit('VDR_LIST_DEL', idx);
    },
    //鼠标进入窗口时显示右上角全屏、关闭功能
    displayKey(event){
      clearTimeout(this.timerId)
      let targetNode = event.target;
      let vdrId = targetNode.getAttribute("id").split("-")[1];
      this.mouseEnterId = vdrId;
      const i = this.record.findIndex((element) => element.win.idx === Number(vdrId));
      const index = this.vdrList.findIndex((element) => element.idx === Number(vdrId));
    //窗口非全屏时的显示全屏标
      if ((this.vdrList[index].w.toFixed() != this.vdrw) || (this.vdrList[index].h.toFixed() != this.vdrh)) {
        this.activ = this.record[i].activ = true
      }
      this.activ = this.record[i].activ
    },
    //鼠标移出时隐藏
    disappearKey(){
      this.timerId = setTimeout(() => {
        this.mouseEnterId = -1
      }, 1000);
      
    }
  },
  computed: {
    scale() {
      return Number(this.$store.state.program.ratio.toFixed(2));
    },
    vdrList() {
      return this.$store.state.program.vdrList;
    },
    vdrIndex() {
      return this.$store.state.program.vdrIndex;
    },
    vdrWindowSize() {
      return this.$store.state.program.vdrWindowSize;
    },
    vdrListLength() {
      return this.$store.getters.getVdrListLength;
    },
    grids() {  //网格布局
        return this.$store.state.program.grids
    },
    vdrStyle() {  
      const type =  this.vdrInfor.type === 'look'? 'none':'auto'        
      return{
        pointerEvents: type
      } 
      // width: `${this.vdrw * this.scale}px`,
      // height: `${this.vdrh * this.scale}px`,
      // background: this.getBackgroundLine(),
    },
    minSize() {  //设置窗口缩放最小值
      return{
        // width: `${this.scale*16}`,
        // height: `${this.scale*16}`
        width: 16,
        height: 16
      }
    },
    windowList1() {
      return JSON.parse(JSON.stringify(this.windowList))
    }
  },
  watch: {
    scale: {
      handler(val) {
        // 页面大小调整时触发,避免更新尺寸错误。
        this.upDateWindowList(val);
        console.log(111)
        this.resize = false;
        setTimeout(() => {
          this.resize = true;
        })
      }
    },
    vdrList: {
      deep:true,
      handler() {
        if(this.windowList.length <= this.vdrList.length){
          const i = this.windowList.findIndex((element)=>element.id === this.vdrList[this.vdrIndex].idx)
          i === -1 && this.addWindowList()
          i !== -1 && this.changeWindowList(i)
        }
        else{
          this.deleteWindowList()
        }
      }
    }, 
    vdrIndex: {
      handler(newVal) {
        this.activeId = this.vdrList.length > 0? Number(this.vdrList[newVal].idx) : -1
      }
    },
    windowList1: {
      deep: true,
      handler(newArr) { 
        newArr.length !== 0 && this.changeVdrList();
      }
    },
    grids: {
      handler(val) {
        this.getRefLineParams(val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.screen {
  position: absolute;
  box-sizing: border-box;
  border: 1px solid rgba($color: #fff, $alpha: 0.5);
  color: rgba($color: #fff, $alpha: 0.6);
  pointer-events: none;
  .s-text {
    font-size: 14px;
  }
}
.prompt {
  color: rgba($color: #fff, $alpha: 0.6);
  font-size: 22px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.vdr-window {
  border: 7px outset #000;
  position: relative;
  .vdr-border{
    border: 5px inset #000;
    position: relative;
    // z-index: 999;
    .vdr-wicket{
      width: 100%;
      height: 100%;
      cursor: move;
      .wicket-child{
        width: 100%;
        height: 100%;     
      }
    }
  }
}

.keys{
  background-color:#000;
  box-sizing: border-box;
  border: 1px solid #d6d6d6; 
  padding: 0 5px;
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 5px;
  display: flex;
  justify-content: space-evenly;
}
.keys .key{
  height: 100%;
  width: 100%;
  background-color: #000;
  font-size: 18px;
  // color: #fff;
  border: 0;
  margin: 0;
  padding: 6px 8px;
}
.keys .key:last-child{
  margin-right: 0;
}
.ref-line {
  // border: 0.5px dashed white;
  // box-sizing: border-box;
  position: absolute;

}
.v-line {
  width: 1px;
  background: linear-gradient(to bottom, white 50%, transparent 50%);
  background-size: 100% 10px;
  pointer-events: none;
}
.h-line {
  height: 1px;
  background: linear-gradient(to right, white 50%, transparent 50%);
  background-size: 10px 100%;
  pointer-events: none;
}
</style>